// src/api/setupAxios.js
import axios from 'axios';
import { getAuth } from 'firebase/auth';
import { appCheckHeader } from '../utils/appcheck';

if (!window.__AXIOS_INTERCEPTOR_SET__) {
    axios.interceptors.request.use(async (config) => {
        // Base URL centralizzata (se vuoi usarla globalmente):
        if (!config.baseURL && process.env.REACT_APP_FUNCTIONS_BASE) {
            config.baseURL = process.env.REACT_APP_FUNCTIONS_BASE;
        }
        // Allego sempre ID token se c'� un utente
        const u = getAuth().currentUser;
        if (u) {
            const t = await u.getIdToken(); // il refresh forzato lo facciamo sul 401
            config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
        }
        // App Check (in prod; in locale il tuo appCheckHeader() ritorna {})
        const ac = await appCheckHeader();
        config.headers = { ...(config.headers || {}), ...ac };
        return config;
    });

    axios.interceptors.response.use(
        (r) => r,
        async (err) => {
            // Se 401, prova UNA volta a forzare il refresh token
            const { config, response } = err || {};
            if (response?.status === 401 && !config.__retried) {
                config.__retried = true;
                const u = getAuth().currentUser;
                if (u) {
                    const fresh = await u.getIdToken(true);
                    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${fresh}` };
                    return axios.request(config);
                }
            }
            return Promise.reject(err ?? new Error('HTTP error'));
        }
    );

    window.__AXIOS_INTERCEPTOR_SET__ = true;
}
